/** Identité du site, telle qu'elle apparaît dans les mentions légales. */
export const SITE_IDENTITY = {
  /** Adresse à laquelle un visiteur peut joindre l'éditeur. */
  contactEmail: "contact@boomap.fr",
  lastUpdated: "2026-09-03",
} as const;
